/** @jsxImportSource @emotion/react */
import React from "react";
import { jsx, css } from "@emotion/react";
import { useEffect, useState, forwardRef } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import Layout from "./Layout";
import { DataGrid, GridToolbarExport, GridToolbarContainer } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { loginState, configState } from "../lib/State";
import {
  Select,
  MenuItem,
  AppBar,
  Toolbar,
  Typography,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormLabel,
  Box,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { ko } from "date-fns/locale";
import moment from "moment";
import GiftFindMember from './GiftFindMember';
import get_gift from "../lib/get_gift";
import get_token from "../lib/get_token";
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css'; // react-bootstrap-table-next
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import add_comma from "../lib/add_comma";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// 등록하기 팝업
function PostCouponDay(props) {

  const { open, setOpen, login, reload, tcid, tdate } = props;
  const token = localStorage.getItem("token");
  const title = '쿠폰매출';
  const [openFindMember, setOpenFindMember] = useState(false); // 쿠폰찾기 팝업
  const [data, setData] = useState({ // 1
    mname: '',
    tmcd: '',
    amount: ''
  });
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState({
    sum1: 0,
    sum2: 0,
    sum3: 0,
  })

  const handleChange = e => {
    setData(state => {
      let newState = state;
      newState[e.target.name] = e.target.value;
      return { ...newState };
    });
  }

  const columns = [
    { field: "id", hide: true },
    { field: "class_date", headerName: '수업일', align: "center" },
    { field: "class_hour", headerName: '시간', align: "center" },
    {
      field: "amount", headerName: '수업금액', align: "center",
      renderCell: (params) => {
        return <Box>{add_comma(params.row.amount)}</Box>;
      }
    },
    {
      field: "point", headerName: '출석', align: "center",
      renderCell: (params) => {
        return <Box>{params.row.point==='1'?'Y':'N'}</Box>;
      }
    },       
    {
      field: "commission", headerName: '가맹수수료', align: "center",
      renderCell: (params) => {
        return <Box>{add_comma(Math.round(params.row.amount / 100 * 0.8))}</Box>;
      }
    },
    {
      field: "pg", headerName: 'PG수수료', align: "center",
      renderCell: (params) => {
        return <Box>{add_comma(Math.round(params.row.amount / 100 * 3.5))}</Box>;
      }
    },
    {
      field: "total", headerName: '합계', align: "center",
      renderCell: (params) => {
        return <Box>{add_comma(Math.round(params.row.amount - (params.row.amount / 100 * 0.8) - (params.row.amount / 100 * 3.5)))}</Box>;
      }
    },
    {
      field: "mname", headerName: '고객명', align: "center",
    },
    {
      field: "tname", headerName: '강사명', align: "center",
    },
    {
      field: "pname", headerName: '상풍명', align: "center",
    },
    {
      field: "sell_price", headerName: '판매가', align: "center",
      renderCell: (params) => {
        return <Box>{add_comma(params.row.sell_price)}</Box>;
      }
    },
    {
      field: "buy_price", headerName: '구매가', align: "center",
      renderCell: (params) => {
        return <Box>{add_comma(params.row.buy_price)}</Box>;
      }
    },
    {
      field: "pt_count", headerName: '수량', align: "center",
      renderCell: (params) => {
        return <Box>{add_comma(params.row.pt_count)}</Box>;
      }
    }
  ];



  // headerName: "회원명",
  // width: 120,
  // align: "center",     

  // const columns = [{
  //   dataField: 'id',
  //   text: 'id',
  //   hidden: true
  // },
  // {
  //   dataField: 'class_date',
  //   text: '수업일',
  //   align: 'center',
  //   headerStyle: { width: 100, textAlign: 'center' }
  // },
  // {
  //   dataField: 'class_hour',
  //   text: '수업시간',
  //   align: 'center',
  //   headerStyle: { width: 90, textAlign: 'center' }
  // }


  //   , {
  //   dataField: 'amount',
  //   text: '수업금액',
  //   align: 'center',
  //   headerStyle: { width: 100, textAlign: 'center' },
  //   formatter: function (cell, row) {
  //     return <Box>{add_comma(cell)}</Box>;
  //   }
  // }
  //   , {
  //   dataField: 'amount',
  //   text: '가맹수수료',
  //   align: 'center',
  //   headerStyle: { width: 100, textAlign: 'center' },
  //   formatter: function (cell, row) {
  //     return <Box>{add_comma(Math.round(cell / 100 * 0.8))}</Box>;
  //   }
  // }
  //   , {
  //   dataField: 'amount',
  //   text: 'PG수수료',
  //   align: 'center',
  //   headerStyle: { width: 100, textAlign: 'center' },
  //   formatter: function (cell, row) {
  //     return <Box>{add_comma(Math.round(cell / 100 * 3.5))}</Box>;
  //   }
  // }
  //   , {
  //   dataField: 'amount',
  //   text: '합계',
  //   align: 'center',
  //   headerStyle: { width: 100, textAlign: 'center' },
  //   formatter: function (cell, row) {
  //     return <Box>{add_comma(Math.round(cell - (cell / 100 * 0.8) - (cell / 100 * 3.5)))}</Box>;
  //   }
  // }
  //   , {
  //   dataField: 'mname',
  //   align: 'center',
  //   headerStyle: { width: 90, textAlign: 'center' },
  //   text: '회원명',
  // }
  //   , {
  //   dataField: 'tname',
  //   text: '강사명',
  //   align: 'center',
  //   headerStyle: { width: 90, textAlign: 'center' }
  // }
  //   , {
  //   dataField: 'pname',
  //   text: '상품명',
  //   align: 'center',
  //   headerStyle: { width: 160, textAlign: 'center' },
  // }
  //   , {
  //   dataField: 'pt_count',
  //   text: '수량',
  //   align: 'center',
  //   headerStyle: { width: 60, textAlign: 'center' }
  // }
  //   , {
  //   dataField: 'sell_price',
  //   text: '판매가',
  //   align: 'center',
  //   headerStyle: { width: 140, textAlign: 'center' },
  //   formatter: function (cell, row) {
  //     return <Box>{add_comma(cell)}</Box>;
  //   }
  // }
  //   , {
  //   dataField: 'buy_price',
  //   text: '구매가',
  //   align: 'center',
  //   headerStyle: { width: 140, textAlign: 'center' },
  //   formatter: function (cell, row) {
  //     return <Box>{add_comma(cell)}</Box>;
  //   }
  // }
  // ];

  const load_data = async () => {

    setRows([]);

    let result = await axios.post(configState.api + "/chart/coupon_calendar_day", {
      token: get_token(),
      cid: login.cid,
      tcid: tcid,
      tdate: tdate,
    });
    if (result.data.success === 1) {
      setRows(result.data.rows);

      // total
      let total_tmp = parseInt(result.data.total);
      let total_sale = total_tmp - (total_tmp/100 * 0.8) - (total_tmp/100* 3.5);


      setTotal({
        sum1: add_comma(total_tmp),        
        sum2: add_comma(Math.round(total_tmp/100 * 0.8)),        
        sum3: add_comma(Math.round(total_tmp/100 * 3.5)),        
        sum4: add_comma(Math.round(total_sale)),        
        sum5: add_comma(Math.round(total_sale-(total_sale*10/110))),        
        sum6: add_comma(Math.round(total_sale*10/110)),        
      });
    }
    else {
      Swal.fire(result.data.msg);
    }
  }

  useEffect(() => {
    if (open) {    
      if(tcid!=='') {
        load_data();
      }      
    }
    
    
    // setData({
    //   mname: '',
    //   tmcd: '',
    //   amount: ''
    // })
  }, [open]);

  // 
  // setOpen(false);
  // load_data(); // 부모창 새로고침
  // }

  return <>

    <Dialog
      open={open}
      fullWidth={true}
      maxWidth="lg"
      TransitionComponent={Transition}
      onClose={() => setOpen(false)}
    >

      <AppBar sx={{ position: "static" }}>
        <Toolbar>
          <Box sx={{ flexGrow: 1 }}>
            <Typography style={{ fontSize: 18 }}>{title}내역</Typography>
          </Box>
          <IconButton
            edge="start"
            color="inherit"
            onClick={() => setOpen(false)}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Box sx={{ p: 1, mt: 2 }}>
        <Box display="flex" fontSize={14}>
          <Box marginLeft={1}>합계:{total.sum1}</Box>
          {/* <Box marginLeft={2}>가맹수수료:{total.sum2}</Box>
          <Box marginLeft={2}>PG수수료:{total.sum3}</Box>
          <Box marginLeft={2} >합계:{total.sum4}</Box>
          <Box marginLeft={2} fontWeight="bold">매출:{total.sum5} / {total.sum6}</Box> */}
        </Box>

        <Box marginTop={1}>
          <DataGrid
            css={css`
              max-width: 1300px;
              min-height: 550px;
            `}
            rows={rows}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[5]}
            checkboxSelection={false}     
            components={{
              zx:3
            }}       
          />
        </Box>

        <Box
          sx={{
            mt: 5, textAlign: "center"
          }}
        >
          <Button
            variant="contained"
            color="warning"
            css={css`
              margin-left: 10px;
            `}
            onClick={() => setOpen(false)}
          >
            닫기
          </Button>
        </Box>
      </Box>
    </Dialog>
  </>
}

export default PostCouponDay;